import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../../enums/eEventTypes';
import EntryPoint from 'Engine/EntryPoint';
import { gsap } from 'gsap';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';

export default class ControllerLabelsThrower {
  constructor(container) {
    this._container = new PIXI.Container();
    container.addChild(this._container);

    this._dropPoint = { x: 0, y: 0 };
    this._processingLabels = [];
    this._timelines = [];
    this.addListeners();
  }

  addListeners() {
    // GlobalDispatcher.add(eEventTypes.EET_THROW_LABEL, this.throw.bind(this));
    GlobalDispatcher.add(eEventTypes.EET_WIN_COLLECT__END, this._onCollectEnd.bind(this));
  }

  updateTargetContainer(container) {
    this.targetContainer = container;
    this.updateDropPoint();
  };

  updateDropPoint() {
    // const offsetX = this.targetContainer.valueContainer.displayData.width / 2;
    const offsetY = this.targetContainer.valueContainer.displayData.height / 2;

    const targetContainerPosition = this._container.toLocal({ x: 0, y: offsetY }, this.targetContainer.valueContainer);
    this._dropPoint = {
      x: targetContainerPosition.x,
      y: targetContainerPosition.y
    };
  }

  throw({ params }) {
    const { symbol, complete } = params;
    const label = symbol.label;
    const labelPosition = { x: label.x, y: label.y };

    this._processingLabels.push({
      label,
      position: labelPosition,
      parent: symbol,
    });

    const startPosition = this._container.toLocal({ x: 0, y: 0 }, label);
    this._container.addChild(label);
    label.x = startPosition.x;
    label.y = startPosition.y;
    label.visible = true;

    const timeline = gsap.timeline({ repeat: 0, delay: 0.2, onStart: this._playCollectSound });
    this._timelines.push(timeline);

    // symbol.scatterShortStop();
    timeline.to(label,
      {
        x: this._dropPoint.x,
        y: this._dropPoint.y,
        duration: 1,
      }
    ).to(label.scale,
      { x: 1.6, y: 1.6, duration: 0.5 }, '<'
    ).to(label.scale,
      { x: 0.1, y: 0.1, duration: 0.5 }, '>'
    ).to(label,
      { alpha: 0, duration: 0.5 }, '<'
    ).call(() => {
      this.targetContainer.add(EntryPoint.GameModel.getBonusAmount(symbol.id), complete);
      label.visible = false;
      label.alpha = 1;
    }, [], '>')
      .call(() => {
        if (complete) GlobalDispatcher.dispatch(eEventTypes.EET_WIN_COLLECT__COMPLETE)
      }, [], '+=1');
  };

  _onCollectEnd() {
    // this.targetContainer.setValue(EntryPoint.GameModel.freespinsTotalWin);

    this._timelines.forEach(timeline => timeline.kill());
    this._timelines = [];

    this._processingLabels.forEach(({ label, position, parent }) => {
      label.visible = false;
      parent.addChild(label);
      label.x = position.x;
      label.y = position.y;
      label.scale.set(1);
    });
    this._processingLabels = [];
  }

  _playCollectSound() {
    // SoundManager.play(eSounds.EST_COLLECT.soundName, eSounds.EST_COLLECT.volume, false, eSounds.EST_COLLECT.group);
  }
}
